'use client'
import { hermesLogger } from '@core/observability'
import { Flex } from '@core/ui-elements'
import { useState } from 'react'

import { LoadingScreen } from '../../loading-screen'
import { useFeedbackToast } from '../hooks/use-feedback-toast'
import { SetIdentificationContentProps } from '../set-identification.types'
import { IDInput } from './id-input/id-input'
import { QRCodeCard } from './qr-code-card'

export const SetIdentificationContent = ({
  handleSubmit,
  closeAfterFinish = true,
  onClose,
}: SetIdentificationContentProps) => {
  const { onErrorFeedback } = useFeedbackToast()

  const [isLoading, setIsLoading] = useState(false)

  const handleSubmitStartChecking = async (id: string) => {
    setIsLoading(true)
    await handleSubmit(id)
      .catch((error) => {
        hermesLogger.warn(`[setIdentification] - Error: ${error.message}`, {
          error,
          path: window.location.pathname,
          typedCode: id,
        })
        onErrorFeedback(error.message)
      })
      .finally(async () => {
        if (closeAfterFinish) await onClose()
        setIsLoading(false)
      })
  }

  if (isLoading) return <LoadingScreen />

  return (
    <Flex flexDirection="column" gap="1rem" height="100%">
      <QRCodeCard />
      <IDInput handleSubmit={handleSubmitStartChecking} isLoading={isLoading} />
    </Flex>
  )
}
